import React from 'react';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelRadio, LabelCabecera } from '../../componentes/componentes_generales/componentes_formulario/labels/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargarCatalogosGenericoAsync, generarItemCatalogoSeleccionado, cargarCatalogoEstados, cargarCatalogosAsync} from '../../funciones_globales/catalogos';
import { cargar_FacturasPendientesGuiaRemisionPorCliente, cargar_GuiaRemision } from '../../actions/ventas/act_ven06';
import { cargar_Cliente, inicializarCliente } from '../../actions/clientes/act_cli01';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { validarCampoString, validarFechaMomentEnFormatoString, validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearFechaMoment_a_String, formatearNumeroDecimal, completar_String } from '../../funciones_globales/format';
import styled from 'styled-components';
import { obtenerSecuencial } from '../../funciones_globales/parametros';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import { seleccionar_PuntoFacturacion } from '../../actions/ventas/act_ven02';

const ContenedorDatosImpresion = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #cfd8dc;
  padding: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const LabelNroGuiaRemisionSri = styled.h6`
  color: red;
  font-weight: 600;
`

class FormVen06 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      guiaRemisionId: '',
      fechaGuiaRemision: null,
      transporte_sel: null,
      cliente_sel: null,
      tipoDestinatario: 'T',
      ciudadEnvio: {codigo: '', descripcion: ''},
      direccionEnvio: {codigo: '', descripcion: ''},
      observacion: '',
      estadoActual: 'A',
      estadosGuiaRemision: [],
      facturas: [],
      cantFila1: '',
      tipoEmpaque1: 'C',
      cantFila2: '',
      tipoEmpaque2: 'C',      
      secuencialGuiaRemision: '',
      nroGuiaRemisionSri: '',
      deshabilitarBotonGuardar: false,
      columnsDefGridFacturas:[
        { header: "",
          width: 25,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true
        },    
        { header: "No.",
          field: "Nro",
          width: 30,
          type: "string"
        },
        { header: "Factura",
          field: "Factura",
          width: 115,
          type: "string"
        },
        { header: "Fecha",
          field: "Fecha",
          width: 75,
          type: "string"
        },        
        { header: "Total",
          field: "Total",
          width: 70,
          type: "num_decimal"
        },
        { header: "Ciudad de Envío",
          field: "CiudadEnvio",
          width: 130,
          type: "string"
        },
        { header: "Dirección de Envío",
          field: "DireccionEnvio",
          width: 340,
          type: "string"
        },
      ]
    };

    this.gridFacturasOptions = {
      rowSelection: 'multiple',      
      enableColResize: true,
      enableSorting: true,
      suppressRowClickSelection: true,
      onRowSelected: (event) =>{
        this.cambiar_y_validarSeleccionFactura(event);
      }     
    };
    
    this.onGridFacturasReady = this.onGridFacturasReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cargarFacturasPendientesGuiaRemision = this.cargarFacturasPendientesGuiaRemision.bind(this);
    this.getGuiaRemisionById = this.getGuiaRemisionById.bind(this);
    this.cambiarClienteSeleccionado = this.cambiarClienteSeleccionado.bind(this);
    this.cambiar_y_validarSeleccionFactura = this.cambiar_y_validarSeleccionFactura.bind(this);
    this.guardarGuiaRemision = this.guardarGuiaRemision.bind(this);
    this.anularGuiaRemision = this.anularGuiaRemision.bind(this);
    this.imprimirGuiaRemision = this.imprimirGuiaRemision.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onGridFacturasReady(params) {
    this.apiGridFacturas = params.api;
    this.columnApiGridFacturas = params.columnApi;
  }

  cambiarClienteSeleccionado(cliente){
    if (this.state.operacion === 'G'){
      this.props.inicializarCliente();

      this.setState({ cliente_sel: cliente,
                      tipoDestinatario: 'T',
                      ciudadEnvio: {codigo: '', descripcion: ''},
                      direccionEnvio: {codigo: '', descripcion: ''},
                      observacion: '',
                      facturas: []
      });

      if (cliente !== null){

        let codigoCliente = cliente.value;

        this.props.cargar_Cliente(codigoCliente)
        .then(()=>{
          if (this.props.cliente===null){            
            return;
          }

          if (this.props.cliente.flete === 'S'){
            alert('El cliente seleccionado tiene establecido el parámetro para que el envio de mercadería se realice por servicio externo.');
            return;
          }

          this.cargarFacturasPendientesGuiaRemision(codigoCliente);

        });    
      }
    }else{
      alert('No está permitido el cambio del cliente.');
    }
  }
  

  cargarFacturasPendientesGuiaRemision(idCliente, facturasAConcatenar=[]){    
    return new Promise((resolve, reject)=>{
      this.props.cargar_FacturasPendientesGuiaRemisionPorCliente(idCliente)
      .then(()=>{
        try{
          let facturas = [];
  
          if(facturasAConcatenar.length > 0){
            facturas = [...facturasAConcatenar];
          }
  
          this.props.facturas.forEach(factura => {
            let nroFactura = (factura.Establec===null?'XXX':factura.Establec) + '-' + (factura.PtoEmision===null?'XXX':factura.PtoEmision) + '-' + factura.NroFactura;
            
            facturas.push({
              Nro: facturas.length + 1,
              Factura: nroFactura,
              IdFactura: factura.Factura,
              Fecha: factura.Fecha,
              Total: factura.Importe,
              CodDireccion: factura.direccionEnvio.idDireccionEnvio,
              CodCiudadEnvio: factura.direccionEnvio.codCiudadEnvio,
              CiudadEnvio: factura.direccionEnvio.descripCiudadEnvio,
              DireccionEnvio: factura.direccionEnvio.descripDireccionEnvio,
              TieneGuia: false
            });
          });        
          
          this.setState({facturas});
          resolve(facturas);  
        }catch(error){
          reject(`Ocurrió un error al consultar las facturas: ${error}`);
        }
      });
    });
  }

  cambiar_y_validarSeleccionFactura(event){
    let facturaSel = event.node.data;
    let facturasSeleccionadas = this.apiGridFacturas.getSelectedRows();    

    if (event.node.selected){
      if (this.state.direccionEnvio.codigo===''){
        this.setState({ direccionEnvio: { codigo: facturaSel.CodDireccion, descripcion: facturaSel.DireccionEnvio },
                        ciudadEnvio: { codigo: facturaSel.CodCiudadEnvio, descripcion: facturaSel.CiudadEnvio }});
      }else{
        if (facturaSel.CodDireccion !== this.state.direccionEnvio.codigo){
          alert('No puede seleccionar facturas que tengan diferentes direcciones de envío.');
          event.node.setSelected(false);
        }
      }
    }else{
      if (facturasSeleccionadas.length===0){
        this.setState({ direccionEnvio: { codigo: '', descripcion: ''},
                        ciudadEnvio: { codigo: '', descripcion: ''}
                      });
      }
    }

    let observacion = '';
    let total = 0;

    facturasSeleccionadas.forEach(fact=>{
      total += parseFloat(fact.Total);
      observacion = observacion.concat(fact.Factura + '; ');
    });

    this.setState({observacion: observacion.concat(' Total: ' + formatearNumeroDecimal(total))});
  }

  componentDidMount(){
    Promise.all([
      cargarCatalogoEstados('GuiaRemision', 'Estado'),      
      obtenerSecuencial('GuiaRemision'),
      this.props.generar_LogAuditoriaIngresoForm('0406')      
    ])
    .then(([estadosGuiaRemision, secGuiaRemision])=>{
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState({ fechaGuiaRemision: moment(fechaProceso, 'DD/MM/YYYY'),
                      estadosGuiaRemision, secuencialGuiaRemision: completar_String(secGuiaRemision.codigo-1, '0', 7)});
    })
    .catch(error => {
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0406');
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;     
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  getOptions_Transportes(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('TRANSPORTE', input, callback)
    }
  }

  getGuiaRemisionById(){
    if (!validarCampoString(this.state.guiaRemisionId, 7)){
      alert("No ha especificado correctamente la Guía de Remisión.");
      return;
    }

    this.props.cargar_GuiaRemision(this.state.guiaRemisionId)
    .then(()=>{
      try {

        let facturasDeGuiaRemisionActual = [];

        if (this.props.guiaRemision === null){
          alert('No existe una Guía de Remisión con el número especificado.');
          return;
        }

        this.props.guiaRemision.detGuia.forEach(item=>{
          facturasDeGuiaRemisionActual.push({
            Nro: item.Secuencia,
            Factura: item.Factura,
            IdFactura: item.IdFactura,
            Fecha: item.fact.Fecha,
            Total: item.fact.Importe,
            CodDireccion: this.props.guiaRemision.direccionEnvio.idDireccionEnvio,
            CodCiudadEnvio: this.props.guiaRemision.direccionEnvio.codCiudadEnvio,
            CiudadEnvio: this.props.guiaRemision.direccionEnvio.descripCiudadEnvio,
            DireccionEnvio: this.props.guiaRemision.direccionEnvio.descripDireccionEnvio,
            TieneGuia: true          
          });
        });

        this.props.cargar_Cliente(this.props.guiaRemision.Cliente);

        this.setState({ operacion: 'M',
                        fechaGuiaRemision: moment(this.props.guiaRemision.Fecha, 'DD/MM/YYYY'),
                        transporte_sel: this.props.guiaRemision.trans!==null?generarItemCatalogoSeleccionado(this.props.guiaRemision.trans.Codigo, this.props.guiaRemision.trans.Descripcion):null,
                        cliente_sel: generarItemCatalogoSeleccionado(this.props.guiaRemision.cli.Codigo, this.props.guiaRemision.cli.Nombre),
                        tipoDestinatario: this.props.guiaRemision.TipoDestinatario,
                        ciudadEnvio: {codigo: this.props.guiaRemision.direccionEnvio.codCiudadEnvio, 
                                      descripcion: this.props.guiaRemision.direccionEnvio.descripCiudadEnvio},
                        direccionEnvio: { codigo: this.props.guiaRemision.direccionEnvio.idDireccionEnvio, 
                                          descripcion: this.props.guiaRemision.direccionEnvio.descripDireccionEnvio},
                        observacion: this.props.guiaRemision.Observacion,
                        estadoActual: this.props.guiaRemision.Estado,
                        nroGuiaRemisionSri: (this.props.guiaRemision.Establec===null?'':`${this.props.guiaRemision.Establec}-`)+
                                            (this.props.guiaRemision.PtoEmision===null?'':`${this.props.guiaRemision.PtoEmision}-`)+
                                            (this.props.guiaRemision.GuiaSri===null?'':`${this.props.guiaRemision.GuiaSri}`)
                                            ,cantFila1: this.props.guiaRemision.cantFila1,
                                            tipoEmpaque1: this.props.guiaRemision.tipoEmpaque1,
                                            cantFila2: this.props.guiaRemision.cantFila2,
                                            tipoEmpaque2: this.props.guiaRemision.tipoEmpaque2,
                      });

        this.cargarFacturasPendientesGuiaRemision(this.props.guiaRemision.Cliente, facturasDeGuiaRemisionActual)
        .then(()=>{
          this.apiGridFacturas.forEachNode(node =>{
            if (node.data.TieneGuia){
              node.setSelected(true);
            }
          });
        })
        .catch(error=>{
          alert(error);
        });
      
      } catch (error) {
        alert(`Ocurrió un error al consultar la Guía de Remisión. Error: ${error}`);
      }
    });    
  }

  guardarGuiaRemision(){
    try{
      let fechaGuiaRemision = formatearFechaMoment_a_String(this.state.fechaGuiaRemision);    
      let codCliente = this.state.cliente_sel===null?null:this.state.cliente_sel.value;
      let codTransporte = this.state.transporte_sel===null?null:this.state.transporte_sel.value;

      if(this.state.operacion==='M'){
        if(!validarCampoString(this.state.guiaRemisionId, 7)){
          alert('No ha especificado correctamente la Guía de Remisión a modificar.');
          return;
        }

        if (this.state.estadoActual!=='A'){
          alert('El estado actual de la Guía de Remisión no permite que se modifique.');
          return;
        }
      }      

      if (!validarCampoString(codCliente, 7)){
        alert('No ha seleccionado un cliente válido.');
        return;
      }

      if (!validarFechaMomentEnFormatoString(fechaGuiaRemision)){
        alert('La fecha de la guia de remisión es inválida.');
        return;
      }

      if(this.props.puntoEmisionSel===null){
        alert('No ha seleccionado el punto de facturación.');
        return;
      }
      
      let fechaProceso = getFechaProcesoPorModulo('04');

      if (this.props.permiteCambioFProceso==='S'){
        let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaGuiaRemision, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
        
        if(!validFProceso.esValida){
          alert(validFProceso.msg);
          return;
        }
      }      

      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      let facturasSel = this.apiGridFacturas.getSelectedRows();

      if (facturasSel.length === 0){
        alert('No ha seleccionado facturas para vincularlas a la guía de remisión.');
        return;
      }

      let guiaRemision = {
        usuario: getItemDatosSesion('usuario'),
        fechaGuiaRemision: fechaGuiaRemision,
        idCliente: codCliente,
        idTransporte: codTransporte,
        codDireccEnvio: this.state.direccionEnvio.codigo,
        tipoDestinatario: this.state.tipoDestinatario,
        observacion: this.state.observacion,
        idRegAudit: this.props.idRegAudit,
        ptoFacturacion: this.props.puntoEmisionSel,
        cantFila1: this.state.cantFila1,
        tipoEmpaque1: this.state.tipoEmpaque1,
        cantFila2: this.state.cantFila2,
        tipoEmpaque2: this.state.tipoEmpaque2,
        detalleFacturas: []
      };

      facturasSel.forEach((factura, i) => {
        guiaRemision.detalleFacturas.push({        
          nroFactura: factura.Factura,
          idFactura: factura.IdFactura
        });
      });

      this.props.cambiar_VisualizacionLoading(true);

      global_axios({
        method: (this.state.operacion==='G')?'POST':'PUT',
        url: (this.state.operacion==='G')?'/guiasremision':`/guiasremision/${this.state.guiaRemisionId}`,
        data: guiaRemision
      })
      .then(response =>{
        this.props.cambiar_VisualizacionLoading(false);
        let nroGuiaRemisionGen = response.data.codigoGuiaRemision;
        let nroGuiaRemisionSri = response.data.nroGuiaRemisionSri;

        if(this.state.operacion==='G'){
          alert('Se generó correctamente la Guía de Remisión No. ' + nroGuiaRemisionGen);
          this.setState({guiaRemisionId: completar_String(nroGuiaRemisionGen, '0', 7), operacion: 'M', nroGuiaRemisionSri});
        }else{
          alert('Se modificó correctamente la Guía de Remisión No. ' + nroGuiaRemisionGen);
        }

        this.setState({deshabilitarBotonGuardar: true});
      })
      .catch(error =>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
      
    }catch(error){
      this.props.cambiar_VisualizacionLoading(false);
      alert(error);
    }
   
  }

  anularGuiaRemision(){
    let guiaRemision = this.state.guiaRemisionId;
    
    if (this.state.operacion!=='M'){
      alert('No ha seleccionado una Guía de Remisión para anular.');
      return;
    }

    if (!validarCampoString(guiaRemision, 7)){
      alert('No ha especificado correctamente la Guía de Remisión a modificar.');
      return;
    }

    if (this.state.estadoActual!=='A'){
      alert('El estado actual de la Guía de Remisión no permite que se anule.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let continuarAnul = window.confirm('¿Está seguro de anular la Guía de Remisión No.: ' + guiaRemision + '?');
  
    if (!continuarAnul){
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);
    
    global_axios({
      method: 'DELETE',
      url: '/guiasremision/' + guiaRemision,
      headers: {'idregaudit': this.props.idRegAudit}
    })
    .then(()=> {
      this.props.cambiar_VisualizacionLoading(false);      
      alert('La Guía de Remisión fue anulada correctamente.');      
      this.limpiar();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });  
  }

  imprimirGuiaRemision(){
    if(validarCampoString(this.state.guiaRemisionId, 7) && this.state.operacion==='M'){
      
      let urlReporteConParams = `&rpt=83&param1=${this.state.guiaRemisionId}`;
      if(validarCampoString(this.state.cantFila1, 1, 10)){
        urlReporteConParams += `&param2=${this.state.cantFila1}`;
        urlReporteConParams += `&param3=${this.state.tipoEmpaque1==='C'?'Cartones':'Lios'}`;
      }

      visualizarReporteEnPdf(urlReporteConParams);
    }else{
      alert('No ha especificado correctamente la Guía de Remisión a imprimir.');
    }
  }

  limpiar(){
    let fechaProceso = getFechaProcesoPorModulo('04');

    this.setState({
      operacion: 'G',
      guiaRemisionId: '',
      fechaGuiaRemision: moment(fechaProceso, 'DD/MM/YYYY'),
      transporte_sel: null,
      cliente_sel: null,
      tipoDestinatario: 'T',
      ciudadEnvio: {codigo: '', descripcion: ''},
      direccionEnvio: {codigo: '', descripcion: ''},
      estadoActual: 'A',
      observacion: '',
      facturas: [],
      cantFila1: '',
      tipoEmpaque1: 'C',
      cantFila2: '',
      tipoEmpaque2: 'C',
      deshabilitarBotonGuardar: false
    });
    this.props.inicializarCliente();
    this.inicializarPuntoFacturacion();
  }

  inicializarPuntoFacturacion(){
    let puntoFacturacionDefault;

    for(let i=0; i<this.props.puntosFacturacion.length; i++){
      if (this.props.puntosFacturacion[i].EsDefault==='S'){
          puntoFacturacionDefault = this.props.puntosFacturacion[i];
          break;
      }
    }
    this.props.seleccionar_PuntoFacturacion(puntoFacturacionDefault.Codigo);
  }


  render(){

    let cliente;
    if (this.props.cliente !== null){
      if (this.state.operacion === 'M'){
        cliente = this.props.cliente;
      }else{
        if (this.props.cliente.flete !== 'S'){
          cliente = this.props.cliente;
        }
      }
    }

    return(      
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Guía de Remisión</TituloForm>
          <LabelCabecera>Últ. Guía de Remisión: {this.state.secuencialGuiaRemision}</LabelCabecera>
        </HeaderForm>
        <CuerpoForm>
            <Row>   
              <ContainerCol className='col-sm-2'>
                <LabelForm>Guía de Remisión:</LabelForm>
                <InputSearch tipoInput='text' nombre='guiaRemisionId' placeholder='Guía de Remisión' valor={this.state.guiaRemisionId}
                  func_CambiarValor={this.handleInputChange} func_BuscarValor={this.getGuiaRemisionById} func_OnFocus={()=>{this.limpiar()}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Fecha:</LabelForm>
                <PickerFecha fechaSeleccionada={this.state.fechaGuiaRemision}
                  func_onChange={(fecha)=>{this.setState({fechaGuiaRemision: fecha})}}
                  disabled={!(this.props.permiteCambioFProceso==='S')}
                />
              </ContainerCol>
              <ContainerCol className='col-sm-4'>
                <LabelForm>Transporte:</LabelForm>
                <ReactSelectAsync value={this.state.transporte_sel} func_loadOptions={this.getOptions_Transportes}
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({transporte_sel: value })}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Estado:</LabelForm>
                <ReactSelect options={ this.state.estadosGuiaRemision } disabled={true} value={this.state.estadoActual}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2' isInvisible={this.state.operacion==='M'}>
                <LabelForm>Pto. Emisión:</LabelForm>
                <PuntoFacturacion/>
              </ContainerCol>
              <ContainerCol className='col-sm-2' isInvisible={this.state.operacion==='G'}>
                <LabelForm>Guía de Remisión SRI:</LabelForm>
                <LabelNroGuiaRemisionSri>{this.state.nroGuiaRemisionSri}</LabelNroGuiaRemisionSri>
              </ContainerCol>
            </Row>
            <Row margen_arriba={10}>
              <ContainerCol className='col-sm-4'>
                <LabelForm>Cliente:</LabelForm>
                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.cambiarClienteSeleccionado(value)}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Ruc:</LabelForm>
                <InputText type='text' value={cliente===undefined?'':cliente.cedula_ruc===undefined?'':cliente.cedula_ruc} disabled={true}/>
              </ContainerCol>
              <ContainerCol className='col-sm-4'>
                <LabelForm>Representante:</LabelForm>
                <InputText type='text' value={cliente===undefined?'':cliente.representante_cia===undefined?'':cliente.representante_cia} disabled={true}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Teléfono:</LabelForm>
                <InputText type='text' value={cliente===undefined?'':cliente.telefono===undefined?'':cliente.telefono} disabled={true}/>
              </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Tipo Destinatario:</LabelForm>
                <div>
                  <LabelRadio><input type='radio' value='T' name='tipoDestinatario' checked={this.state.tipoDestinatario==='T'} 
                    onChange={this.handleInputChange}/>Titular</LabelRadio>
                  <LabelRadio><input type='radio' value='R' name='tipoDestinatario' checked={this.state.tipoDestinatario==='R'}
                    onChange={this.handleInputChange}/>Representante</LabelRadio>
                </div>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Ciudad de Envío:</LabelForm>
                <InputText type='text' value={this.state.ciudadEnvio.descripcion} disabled={true}/>
              </ContainerCol>
              <ContainerCol className='col-sm-6'>
                <LabelForm>Dirección de Envío:</LabelForm>
                <InputText type='text' value={this.state.direccionEnvio.descripcion} disabled={true}/>
              </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-12'>
                <LabelForm>Observación:</LabelForm>
                <InputText type='text' name='observacion' maxLength='100' disabled={true} value={this.state.observacion} onChange={this.handleInputChange}/>
              </ContainerCol>              
            </Row>
            <Row>
              <ContainerCol className='col-sm-9'>
                <AgGridRender altura='300px' data={this.state.facturas} columnas={this.state.columnsDefGridFacturas}
                gridOptions={this.gridFacturasOptions} onGridReady={this.onGridFacturasReady}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>                
                  <ContenedorDatosImpresion>
                    <Row>
                      <ContainerCol className='col-sm-4'>
                        <LabelForm>Fila 1:</LabelForm>
                      </ContainerCol>
                      <ContainerCol className='col-sm-8'>
                        <LabelForm>Cant:</LabelForm>
                        <InputText type='number' name='cantFila1' value={this.state.cantFila1} onChange={this.handleInputChange}/>
                        <LabelRadio>
                          <input type="radio" name="tipoEmpaque1" value="C" checked={this.state.tipoEmpaque1==="C"} onChange={this.handleInputChange}/>
                          Cartones
                        </LabelRadio>
                        <LabelRadio>
                          <input type="radio" name="tipoEmpaque1" value="L" checked={this.state.tipoEmpaque1==="L"} onChange={this.handleInputChange}/>
                          Lios
                        </LabelRadio>
                      </ContainerCol>
                    </Row>
                    <Row>
                      <ContainerCol className='col-sm-4'>
                        <LabelForm>Fila 2:</LabelForm>
                      </ContainerCol>
                      <ContainerCol className='col-sm-8'>
                        <LabelForm>Cant:</LabelForm>
                        <InputText type='number' name='cantFila2' value={this.state.cantFila2} onChange={this.handleInputChange}/>
                        <LabelRadio>
                          <input type="radio" name="tipoEmpaque2" value="C" checked={this.state.tipoEmpaque2==="C"} onChange={this.handleInputChange}/>
                          Cartones
                        </LabelRadio>
                        <LabelRadio>
                          <input type="radio" name="tipoEmpaque2" value="L" checked={this.state.tipoEmpaque2==="L"} onChange={this.handleInputChange}/>
                          Lios
                        </LabelRadio>
                      </ContainerCol>
                    </Row>
                  </ContenedorDatosImpresion>                
              </ContainerCol>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>
                  <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarGuiaRemision}
                    disabled={this.state.deshabilitarBotonGuardar}>
                    <i className='fa fa-floppy-o fa-lg'/>{this.state.operacion==='G'?' Guardar':' Modificar'}</button>
                  <button type='button' className='btn btn-success btn-sm' disabled={this.state.operacion==='G'?true:false}
                    onClick={this.imprimirGuiaRemision}><i className='fa fa-print fa-lg'/> Imprimir</button>
                  <button type='button' className='btn btn-danger btn-sm' onClick={this.anularGuiaRemision} disabled={this.state.operacion==='G'?true:false}><i className='fa fa-window-close fa-lg'/> Anular</button>
                  <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                </div>
              </div>
            </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }
  
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,            
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            facturas: state.ventas.facturas,
            cliente: state.clientes.clienteSel,
            guiaRemision: state.ventas.guiaRemisionSel,
            puntoEmisionSel: state.ventas.ptoFacturacionSel,
            puntosFacturacion: state.ventas.puntosFact
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                              cargar_FacturasPendientesGuiaRemisionPorCliente,
                              cargar_Cliente, cambiar_VisualizacionLoading,
                              inicializarCliente, cargar_GuiaRemision,
                              seleccionar_PuntoFacturacion
                             }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen06);